
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/video/[title]/[mediaId]",
      function () {
        return require("private-next-pages/(ocelot)/video/[title]/[mediaId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/video/[title]/[mediaId]"])
      });
    }
  